export const TechnologistStatuses = [
  { value: 'INPROGRESS', label: 'Program folyamatban' },
  { value: 'COMPLETED', label: 'Program kész' },
  { value: 'SUSPENDED', label: 'Program felfüggesztve' },
  { value: 'NORMACOMPLETED', label: 'Norma kész' },
  { value: 'NORMAINPROGRESS', label: 'Norma folyamatban' },
  { value: 'NORMASUSPENDED', label: 'Norma felfüggesztve' },
  { value: 'FULLDOC', label: 'Komplett dokumentáció' },
  { value: 'NONE', label: 'Üres' },
];
